import { render } from "./AdminModal.vue?vue&type=template&id=2303ff72&scoped=true&ts=true"
import script from "./AdminModal.vue?vue&type=script&lang=ts"
export * from "./AdminModal.vue?vue&type=script&lang=ts"

import "./AdminModal.vue?vue&type=style&index=0&id=2303ff72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2303ff72"]])

export default __exports__